var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentSaveImportable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-3H5z",
    fill: "#3498db"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3H7z",
    fill: "#2980b9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3v5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3H7zM6 12a1 1 0 0 0-1 1v8h14v-8a1 1 0 0 0-1-1H6z",
    fill: "#ecf0f1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bdc3c7",
    d: "M5 20h14v1H5zM7 14h10v1H7zM7 16h10v1H7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3498db",
    d: "M13 4h3v4h-3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2980b9",
    d: "M13 4h3v1h-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSaveImportable);
export default __webpack_public_path__ + "static/media/document-save-importable.ddfaa4d7a821b4518de3ca16e3b8ce54.svg";
export { ForwardRef as ReactComponent };